import Debug from "./theme/debug.js";
import Helpers from "./theme/helpers.js";

import TestComponent from "./theme/components/test-component.js";
import Faqs from "./theme/components/faqs.js";
import FaqsTabs from "./theme/components/faqs-tabs.js";
import FaqsSelect from "./theme/components/faqs-select.js";
import Switcher from "./theme/components/switcher.js";
import Modal from "./theme/components/modal.js";
import MobileNavigation from "./theme/components/mobile-navigation.js";

window.theme = {
	globals: {
		isTouch: typeof window !== "undefined" && "ontouchstart" in window,
	},
	init: function () {
		let theme = this;

		theme.debug = new Debug();
		theme.helpers = new Helpers();

		theme.testComponent = new TestComponent();
		theme.faqs = new Faqs();
		theme.faqsTabs = new FaqsTabs();
		theme.faqsSelect = new FaqsSelect();
		theme.switcher = new Switcher();
		theme.modal = new Modal();
		theme.mobileNavigation = new MobileNavigation();
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});
